/**
 * @generated SignedSource<<28e06459a83ac38d3ba61c081cd1b5fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DurationBasedAgendaScreenQuery$variables = {
  facilitySlug: string;
};
export type DurationBasedAgendaScreenQuery$data = {
  readonly facility: {
    readonly club: {
      readonly " $fragmentSpreads": FragmentRefs<"useGetClubStartOfWeekNumberPatron_club">;
    } | null | undefined;
    readonly id: string;
    readonly startEndTime: {
      readonly endTime: string | null | undefined;
      readonly startTime: string | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"DurationBasedAgendaFragment_facility" | "DurationBasedAgendaHeaderFragment_facility" | "DurationBasedAgendaSidebarFragment_facility">;
  } | null | undefined;
  readonly session: {
    readonly " $fragmentSpreads": FragmentRefs<"DurationBasedAgendaFragment_session" | "DurationBasedAgendaHeaderFragment_session" | "DurationBasedAgendaSidebar_session">;
  } | null | undefined;
};
export type DurationBasedAgendaScreenQuery = {
  response: DurationBasedAgendaScreenQuery$data;
  variables: DurationBasedAgendaScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "facilitySlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "facilitySlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "FacilityStartEndTime",
  "kind": "LinkedField",
  "name": "startEndTime",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endTime",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
],
v9 = [
  (v2/*: any*/)
],
v10 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DurationBasedAgendaScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DurationBasedAgendaHeaderFragment_facility"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DurationBasedAgendaFragment_facility"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DurationBasedAgendaSidebarFragment_facility"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "club",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useGetClubStartOfWeekNumberPatron_club"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DurationBasedAgendaHeaderFragment_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DurationBasedAgendaFragment_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DurationBasedAgendaSidebar_session"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DurationBasedAgendaScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CourseBucketConnection",
            "kind": "LinkedField",
            "name": "courseBuckets",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CourseBucketEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseBucket",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityCopyOverrides",
            "kind": "LinkedField",
            "name": "copyOverrides",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NounOverride",
                "kind": "LinkedField",
                "name": "course",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "singular",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plural",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "bookingType",
                "value": "STANDARD"
              }
            ],
            "concreteType": "GroupSize",
            "kind": "LinkedField",
            "name": "minMaxGroupSize",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "min",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "max",
                "storageKey": null
              }
            ],
            "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicBookingWindowDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "club",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "calendarStartDay",
                "storageKey": null
              },
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "logoImage",
                "plural": false,
                "selections": [
                  {
                    "alias": "publicId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "renderingKey",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Department",
            "kind": "LinkedField",
            "name": "department",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayNameOrFacilityName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memberBookingWindowDays",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityConnection",
                        "kind": "LinkedField",
                        "name": "facilities",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportsPrivate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportsPublic",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PublicBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "publicBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PrivateBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "privateBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Department",
                                    "kind": "LinkedField",
                                    "name": "department",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v2/*: any*/),
                                      (v5/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "Member",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effectiveClientClass",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fa5db27ae3db7d6193de9ae63e1d2898",
    "id": null,
    "metadata": {},
    "name": "DurationBasedAgendaScreenQuery",
    "operationKind": "query",
    "text": "query DurationBasedAgendaScreenQuery(\n  $facilitySlug: String!\n) {\n  facility(slug: $facilitySlug) {\n    id\n    startEndTime {\n      startTime\n      endTime\n    }\n    ...DurationBasedAgendaHeaderFragment_facility\n    ...DurationBasedAgendaFragment_facility\n    ...DurationBasedAgendaSidebarFragment_facility\n    club {\n      ...useGetClubStartOfWeekNumberPatron_club\n      id\n    }\n  }\n  session {\n    ...DurationBasedAgendaHeaderFragment_session\n    ...DurationBasedAgendaFragment_session\n    ...DurationBasedAgendaSidebar_session\n  }\n}\n\nfragment CourseBucketFilterControlFragment_facility on Facility {\n  courseBuckets {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  copyOverrides {\n    course {\n      singular\n    }\n  }\n}\n\nfragment DateSelectorControlFragment_facility on Facility {\n  startEndTime {\n    startTime\n    endTime\n  }\n  id\n  publicBookingWindowDays\n  durations\n  club {\n    ...useGetClubStartOfWeekNumberPatron_club\n    id\n  }\n}\n\nfragment DurationBasedAgendaFragment_facility on Facility {\n  startEndTime {\n    startTime\n    endTime\n  }\n  id\n  club {\n    slug\n    id\n  }\n  memberBookingWindowDays\n  durations\n  minMaxGroupSize(bookingType: STANDARD) {\n    min\n    max\n  }\n}\n\nfragment DurationBasedAgendaFragment_session on Session {\n  effectiveClientClass\n  user {\n    __typename\n    ... on MemberUser {\n      id\n    }\n    id\n  }\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment DurationBasedAgendaHeaderFragment_facility on Facility {\n  ...useGetDurationBasedAgendaFilterBarValues_facility\n  ...DurationBasedFiltersModalFragment_facility\n  name\n  displayNameOrFacilityName\n  memberBookingWindowDays\n  club {\n    name\n    logoImage {\n      publicId: renderingKey\n    }\n    ...FacilityLogoFragment_club\n    id\n  }\n}\n\nfragment DurationBasedAgendaHeaderFragment_session on Session {\n  ...DurationBasedFiltersModal_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Member {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment DurationBasedAgendaSidebarFragment_facility on Facility {\n  id\n  ...useFacilityStartEndTime_facility\n  ...useFacilityGroupSize_facility\n  ...CourseBucketFilterControlFragment_facility\n  ...DurationFilterControlFragment_facility\n  ...DateSelectorControlFragment_facility\n  ...facilityToScheduleOption_facility\n}\n\nfragment DurationBasedAgendaSidebar_session on Session {\n  ...ScheduleSwitcher_session\n}\n\nfragment DurationBasedFiltersModalFragment_facility on Facility {\n  ...useFacilityStartEndTime_facility\n  ...useFacilityGroupSize_facility\n  ...CourseBucketFilterControlFragment_facility\n  ...DurationFilterControlFragment_facility\n  ...DateSelectorControlFragment_facility\n  ...facilityToScheduleOption_facility\n}\n\nfragment DurationBasedFiltersModal_session on Session {\n  ...ScheduleSwitcher_session\n}\n\nfragment DurationFilterControlFragment_facility on Facility {\n  id\n  durations\n}\n\nfragment FacilityLogoFragment_club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment ScheduleSwitcher_session on Session {\n  ...useGetScheduleSwitcherOptionsFragment_session\n}\n\nfragment departmentToScheduleOption_department on Department {\n  type\n  id\n  slug\n  name\n}\n\nfragment facilityToScheduleOption_facility on Facility {\n  id\n  slug\n  name\n  type\n  department {\n    type\n    id\n  }\n}\n\nfragment getFacilityMemberPermissions_facility on Facility {\n  club {\n    id\n    supportsPrivate\n    supportsPublic\n  }\n  publicBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n  privateBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n}\n\nfragment useFacilityGroupSize_facility on Facility {\n  minMaxGroupSize(bookingType: STANDARD) {\n    min\n    max\n  }\n}\n\nfragment useFacilityStartEndTime_facility on Facility {\n  startEndTime {\n    startTime\n    endTime\n  }\n}\n\nfragment useGetClubStartOfWeekNumberPatron_club on Club {\n  calendarStartDay\n}\n\nfragment useGetDurationBasedAgendaFilterBarValues_facility on Facility {\n  startEndTime {\n    startTime\n    endTime\n  }\n  courseBuckets {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  copyOverrides {\n    course {\n      singular\n      plural\n    }\n  }\n}\n\nfragment useGetScheduleSwitcherOptionsFragment_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        facilities {\n          edges {\n            node {\n              type\n              id\n              ...getFacilityMemberPermissions_facility\n              ...facilityToScheduleOption_facility\n              department {\n                id\n                type\n                ...departmentToScheduleOption_department\n              }\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b938e222a334778ec29c26f2dfdc41d";

export default node;
